import React from 'react';
import { Link } from 'react-router-dom';
import { FREE_TRIAL_PLAN_NAME } from '../../helpers/subscription.helpers';
import '../start/PasswordGate.css';
import './FlowDiagramPage.css';

/**
 * Reference page ΓÇö intended authentication & subscription workflow.
 * Route: #/flow
 */
const FlowDiagramPage = () => (
  <div className="xk-flow-page">
    <div className="xk-flow-wrap">
      <header className="xk-flow-header">
        <img
          src={`${process.env.PUBLIC_URL || ''}/XLog3D Logo_Red.png`}
          alt="XLog3D"
          className="xk-gate__logo"
        />
        <h1>App Flow ΓÇö Login to Subscription</h1>
        <p>
          Complete account workflow: Login, User Access Gate, Register, then Subscription.
          Use this page as the build reference.
        </p>
      </header>

      <section className="xk-flow-section">
        <h2>Main Flow Diagram</h2>
        <div className="xk-flow-diagram">
          <div className="xk-flow-node xk-flow-node--start">
            <div className="xk-flow-node__title">App Launch</div>
            <div className="xk-flow-node__route">#/ (empty hash)</div>
            <p className="xk-flow-node__desc">User opens XLog3D desktop / web app</p>
          </div>

          <div className="xk-flow-arrow">Always first screen</div>

          <div className="xk-flow-node xk-flow-node--auth">
            <div className="xk-flow-node__title">1. Login</div>
            <div className="xk-flow-node__route">#/login</div>
            <p className="xk-flow-node__desc">
              Email + Password. Links: Forgot password, Need an account? Register
            </p>
          </div>

          <div className="xk-flow-arrow">User action</div>

          <div className="xk-flow-node xk-flow-node--decision">
            <div className="xk-flow-node__title">Account exists?</div>
            <p className="xk-flow-node__desc">Backend checks email on login attempt</p>
          </div>

          <div className="xk-flow-branch">
            <div className="xk-flow-branch-col">
              <span className="xk-flow-branch-label">YES ΓÇö Existing user</span>
              <div className="xk-flow-node xk-flow-node--auth">
                <div className="xk-flow-node__title">Login success</div>
                <p className="xk-flow-node__desc">
                  Correct password + verified email ΓåÆ session created
                </p>
              </div>
              <div className="xk-flow-arrow">Check subscription</div>
              <div className="xk-flow-node xk-flow-node--decision">
                <div className="xk-flow-node__title">Has active access?</div>
                <p className="xk-flow-node__desc">Trial active OR paid plan active</p>
              </div>
              <div className="xk-flow-arrow">Yes ΓåÆ Home</div>
              <div className="xk-flow-node xk-flow-node--home">
                <div className="xk-flow-node__title">Home / Walkthrough</div>
                <div className="xk-flow-node__route">#/</div>
                <p className="xk-flow-node__desc">Engineering tools unlocked</p>
              </div>
              <div className="xk-flow-arrow">No ΓåÆ Subscription</div>
              <div className="xk-flow-node xk-flow-node--sub">
                <div className="xk-flow-node__title">5. Subscription</div>
                <div className="xk-flow-node__route">#/subscription</div>
                <p className="xk-flow-node__desc">{FREE_TRIAL_PLAN_NAME} or paid plan</p>
              </div>
            </div>

            <div className="xk-flow-branch-col">
              <span className="xk-flow-branch-label xk-flow-branch-label--no">NO ΓÇö New user</span>
              <div className="xk-flow-node xk-flow-node--gate">
                <div className="xk-flow-node__title">2. User Access Gate</div>
                <div className="xk-flow-node__route">#/access</div>
                <p className="xk-flow-node__desc">
                  Name, Affiliation, Country, Email, Password
                  <br />
                  <strong>Password:</strong> the user&apos;s own (min 8 chars)
                </p>
              </div>
              <div className="xk-flow-arrow">PROCEED ΓåÆ API check email</div>
              <div className="xk-flow-node xk-flow-node--decision">
                <div className="xk-flow-node__title">Email in database?</div>
                <p className="xk-flow-node__desc">POST /auth/gate-proceed</p>
              </div>
              <div className="xk-flow-arrow">New email</div>
              <div className="xk-flow-node xk-flow-node--register">
                <div className="xk-flow-node__title">3. Create Account</div>
                <div className="xk-flow-node__route">#/login?mode=register</div>
                <p className="xk-flow-node__desc">
                  Name, Email, Password, Confirm Password (Name &amp; Email pre-filled from gate)
                </p>
              </div>
              <div className="xk-flow-arrow">Create Account ΓåÆ auto sign-in</div>
              <div className="xk-flow-node xk-flow-node--sub">
                <div className="xk-flow-node__title">4. Subscription</div>
                <div className="xk-flow-node__route">#/subscription</div>
                <p className="xk-flow-node__desc">
                  Direct redirect — Login page skipped. Start {FREE_TRIAL_PLAN_NAME} or choose a plan.
                </p>
              </div>
              <div className="xk-flow-arrow">Later visits</div>
              <div className="xk-flow-node xk-flow-node--auth">
                <div className="xk-flow-node__title">Login (returning user)</div>
                <div className="xk-flow-node__route">#/login</div>
                <p className="xk-flow-node__desc">
                  Same email + password set on Create Account
                </p>
              </div>
            </div>
          </div>

          <div className="xk-flow-arrow">After trial or payment</div>

          <div className="xk-flow-node xk-flow-node--home">
            <div className="xk-flow-node__title">6. Home / Engineering App</div>
            <div className="xk-flow-node__route">#/</div>
            <p className="xk-flow-node__desc">Walkthrough ΓåÆ Disclaimer ΓåÆ Tunnel tools</p>
          </div>
        </div>

        <div className="xk-flow-legend">
          <div className="xk-flow-legend-item">
            <span className="xk-flow-legend-dot" style={{ borderColor: '#43a047', background: '#f1f8e9' }} />
            Auth screens
          </div>
          <div className="xk-flow-legend-item">
            <span className="xk-flow-legend-dot" style={{ borderColor: '#f9a825', background: '#fff8e1' }} />
            Gate
          </div>
          <div className="xk-flow-legend-item">
            <span className="xk-flow-legend-dot" style={{ borderColor: '#00897b', background: '#e0f2f1' }} />
            Subscription
          </div>
          <div className="xk-flow-legend-item">
            <span className="xk-flow-legend-dot" style={{ borderColor: '#1565c0', background: '#e3f2fd' }} />
            App home
          </div>
        </div>
      </section>

      <section className="xk-flow-section">
        <h2>Gate ΓÇö Existing Email Shortcut</h2>
        <div className="xk-flow-diagram">
          <div className="xk-flow-node xk-flow-node--gate">
            <div className="xk-flow-node__title">User Access Gate</div>
            <p className="xk-flow-node__desc">User enters email that already exists in DB</p>
          </div>
          <div className="xk-flow-arrow">gate-proceed ΓåÆ existing user</div>
          <div className="xk-flow-node xk-flow-node--decision">
            <div className="xk-flow-node__title">Has subscription?</div>
          </div>
          <div className="xk-flow-branch">
            <div className="xk-flow-branch-col">
              <span className="xk-flow-branch-label">Yes</span>
              <div className="xk-flow-node xk-flow-node--home">
                <div className="xk-flow-node__title">Home</div>
                <div className="xk-flow-node__route">#/</div>
              </div>
            </div>
            <div className="xk-flow-branch-col">
              <span className="xk-flow-branch-label xk-flow-branch-label--no">No</span>
              <div className="xk-flow-node xk-flow-node--sub">
                <div className="xk-flow-node__title">Subscription</div>
                <div className="xk-flow-node__route">#/subscription</div>
              </div>
            </div>
          </div>
        </div>
        <div className="xk-flow-note">
          <strong>Note:</strong> Gate does not ask for account password ΓÇö only the shared access code.
          Existing users skip Register and are signed in automatically.
        </div>
      </section>

      <section className="xk-flow-section">
        <h2>Screen Reference</h2>
        <table className="xk-flow-table">
          <thead>
            <tr>
              <th>Step</th>
              <th>Screen</th>
              <th>Route</th>
              <th>Fields / Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Login</td>
              <td><code>#/login</code></td>
              <td>Email, Password ┬╖ Forgot password ┬╖ Register link</td>
            </tr>
            <tr>
              <td>2</td>
              <td>User Access Gate</td>
              <td><code>#/access</code></td>
              <td>Name, Affiliation, Country, Email, Password (the user&apos;s own, min 8 chars)</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Create Account</td>
              <td><code>#/login?mode=register</code></td>
              <td>Name, Affiliation, Country, Email, Password</td>
            </tr>
            <tr>
              <td>3b</td>
              <td>Verify Email</td>
              <td><code>#/verify-email?token=ΓÇª</code></td>
              <td>Link from email (or dev link in console)</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Login (after register)</td>
              <td><code>#/login</code></td>
              <td>Same credentials ΓåÆ must be verified</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Subscription</td>
              <td><code>#/subscription</code></td>
              <td>21-day {FREE_TRIAL_PLAN_NAME} OR Professional plan (Razorpay)</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Home</td>
              <td><code>#/</code></td>
              <td>Walkthrough, tunnel modules, dashboard</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="xk-flow-section">
        <h2>Rules (Must Follow)</h2>
        <table className="xk-flow-table">
          <tbody>
            <tr>
              <td><strong>Entry point</strong></td>
              <td>App always opens on <code>#/login</code> ΓÇö not gate, not subscription</td>
            </tr>
            <tr>
              <td><strong>New user path</strong></td>
              <td>Login ΓåÆ Register link ΓåÆ Gate ΓåÆ Create Account ΓåÆ Verify Email ΓåÆ Login ΓåÆ Subscription ΓåÆ Home</td>
            </tr>
            <tr>
              <td><strong>Returning user</strong></td>
              <td>Login ΓåÆ (Subscription if needed) ΓåÆ Home</td>
            </tr>
            <tr>
              <td><strong>Gate password</strong></td>
              <td>Shared beta code only ΓÇö not the user&apos;s account password</td>
            </tr>
            <tr>
              <td><strong>Account password</strong></td>
              <td>Set on Register ΓÇö used only on Login afterward</td>
            </tr>
            <tr>
              <td><strong>Subscription gate</strong></td>
              <td>Home and all engineering routes blocked until trial or plan is active</td>
            </tr>
            <tr>
              <td><strong>Logout</strong></td>
              <td>Clear session ΓåÆ back to <code>#/login</code></td>
            </tr>
          </tbody>
        </table>
      </section>

      <div className="xk-flow-actions">
        <Link to="/subscription" className="xk-flow-back">
          Go to Subscription (current app)
        </Link>
      </div>
    </div>
  </div>
);

export default FlowDiagramPage;
